export default __webpack_public_path__ + "static/media/logo.55b2bbd7.png";